import { render } from "./Receta.vue?vue&type=template&id=6ffe800f&scoped=true"
import script from "./Receta.vue?vue&type=script&lang=js"
export * from "./Receta.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=6ffe800f&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffe800f"]])

export default __exports__